import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';


const CodeSnippet = ({ snippet }) => {
    return (
        <div style={{ marginTop: 10, maxWidth: '85vw' }}>
            <a className='orangeIconBtn'
                target="_blank"
                rel="noopener noreferrer"
                href={snippet.source.link}
                style={{
                    marginBottom: -8,
                    marginLeft: 10,
                    width: 'fit-content',
                    padding: '0 7px',
                    borderRadius: '5px 5px 0 0 ',
                    backgroundColor: 'var(--mdGray)',
                    borderWidth: "1px 1px 0 1px",
                    borderStyle: 'solid',
                    maxWidth: '80vw',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    display: 'block',
                    direction: 'rtl'
                }}
            >
                {snippet.source.name}
            </a>
            <SyntaxHighlighter language="vhdl" style={dracula}>
                {snippet.code}
            </SyntaxHighlighter>
        </div>

    );
};

export default CodeSnippet;